import { render, staticRenderFns } from "./SyndicAccordion.vue?vue&type=template&id=2a22781a"
import script from "./SyndicAccordion.vue?vue&type=script&lang=ts"
export * from "./SyndicAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports